module.exports = __webpack_public_path__ + "media/product/f-1-064ad840.png";